import React from 'react';
import styled, { css } from 'styled-components';

import { ButtonNextLink } from '@/components/Button';
import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import { media } from '@/utils/mixin';
import { getTheme } from '@/constants/theme';

function AboutModel() {
  const data = useTypedSelector(selectDetailedCarData);
  const theme = getTheme();

  if (
    !data ||
    theme !== 'main' ||
    !data.catalog.brand.slug ||
    !data.catalog.model?.slug
  ) {
    return null;
  }

  const {
    catalog: { brand, model },
  } = data;

  const catalogUrl = `/catalog/${brand.slug}/${model.slug}`;

  return (
    <Component>
      <StyledButtonNextLink variant="outlined" size="small" to={catalogUrl}>
        О модели
      </StyledButtonNextLink>
    </Component>
  );
}

export default AboutModel;

const Component = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;

  ${media.tablet(css`
    margin-top: 10px;
    justify-content: flex-end;
  `)}
`;

const StyledButtonNextLink = styled(ButtonNextLink)`
  max-width: 130px;
`;
